import { useEffect, useState } from "react"
import { Link, useNavigate } from "react-router-dom";
import styles from './cssModules/index.module.css';
import nothing from './gallary/nothing.png';

export default function OnTransitDB({ loginStatus }) {

    const apiURL = process.env.REACT_APP_SELLER;
    const userUrl = process.env.REACT_APP_API_URL;
    const [totalItems, setTotalItems] = useState(0);
    const [totalValue, setTotalValue] = useState(0);
    const [prodls, setProdLs] = useState();

    const [loading, setLoading] = useState(false);

    const [pageno, setPageno] = useState(1);
    const [noOfObs, setNoOfObs] = useState(null);

    const navigate = useNavigate();

    let S3_URL = process.env.REACT_APP_S3_URL;

    let jToken = localStorage.getItem('token');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${apiURL}/api/ontransit`, {
                    method: 'GET',
                    headers: {
                        'Content-type': 'Application/json',
                        'Authorization': `Bearer ${jToken}`
                    },
                    credentials: "include"
                })
                if (response.status === 500) {
                    throw new Error('Error while fetching on transit data');
                } else {
                    if (response.status === 200) {
                        const res = await response.json();
                        setTotalItems(res.metrics?.totalOntransit);
                        setTotalValue(res.metrics?.totalOntransitVolume ? res.metrics.totalOntransitVolume : 0);
                        setProdLs(res.items);
                        setNoOfObs(res.noObs);
                        setLoading(true);
                    } else {
                        await loginStatus();
                        navigate('/login');
                    }
                }
            } catch (error) {
                // await loginStatus();
                navigate('/error');
                console.log(error.message);
            }
        }
        fetchData();
    }, [jToken, loginStatus, apiURL, navigate])

    const changePage = async (event, ind) => {
        try {
            event.preventDefault();
            const increment = !ind ? 1 : -1;
            const response = await fetch(`${apiURL}/api/ontransit`, {
                method: 'POST',
                headers: {
                    'Content-type': 'Application/json',
                    'Authorization': `Bearer ${jToken}`
                },
                body: JSON.stringify({
                    pageNo: pageno + increment
                }),
                credentials: "include"
            })
            if (response.status === 500) {
                throw new Error('Error while change the page');
            } else {
                if (response.status === 200) {
                    const res = await response.json();
                    setProdLs(res.prod);
                    setNoOfObs(res.noObs);
                } else {
                    await loginStatus();
                    navigate('/login');
                }
            }
        } catch (error) {
            await loginStatus();
            navigate('/error');
            console.log(error.message);
        }
    }

    const [requestingPickup, setRequestingPickup] = useState(false);

    // Delhivery's Pickup Request API works on a package COUNT for the seller's whole warehouse,
    // not specific waybills — the backend does its own authoritative count of what's still
    // waiting, so this button doesn't need to know which page of prodls it's looking at.
    async function requestPickup() {
        try {
            setRequestingPickup(true);
            const response = await fetch(`${apiURL}/api/requestPickup`, {
                method: 'POST',
                headers: {
                    'Content-type': 'Application/json',
                    'Authorization': `Bearer ${jToken}`
                },
                body: JSON.stringify({}),
                credentials: "include"
            });

            if (response.status === 200) {
                const res = await response.json();
                alert(`Pickup requested for ${res.count} package(s) on ${res.pickup_date} at ${res.pickup_time}.`);
            } else if (response.status === 400) {
                const res = await response.json();
                alert(res.message || 'Could not request pickup right now.');
            } else if (response.status === 403) {
                await loginStatus();
                navigate('/login');
            } else {
                throw new Error('Error while requesting pickup');
            }
        } catch (error) {
            console.log(error.message);
            alert('Something went wrong while requesting pickup, please try again.');
        } finally {
            setRequestingPickup(false);
        }
    }

    async function downloadInvoice(id, name) {
        try {
            let response = await fetch(`${apiURL}/api/downloadInvoice`, {
                method: 'POST',
                headers: {
                    'Content-type': 'Application/json',
                    'Authorization': `Bearer ${jToken}`
                },
                body: JSON.stringify({
                    id: id
                }),
                credentials: "include"
            })

            if (response.status === 400) {
                alert('Error during downloading invoice, please try later!');
            } else if (response.status === 500) {
                throw new Error('Server error while downloading invoice');
            } else {
                const arrayBuffer = await response.arrayBuffer();
                const uint8 = new Uint8Array(arrayBuffer);
                console.log('downloadInvoice - byteLength:', arrayBuffer.byteLength,
                    '| first 4 bytes:', uint8[0], uint8[1], uint8[2], uint8[3],
                    '| decoded:', String.fromCharCode(uint8[0], uint8[1], uint8[2], uint8[3]));
                const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
                const url = URL.createObjectURL(blob);
                window.open(url, '_blank');
                const a = document.createElement('a');
                a.href = url;
                a.download = name + '.pdf';
                document.body.appendChild(a);
                a.click();
                a.remove();
                setTimeout(() => URL.revokeObjectURL(url), 5000);
            }
        } catch (error) {
            navigate('/error');
            console.log(error.message);
        }
    }

    return (
        <>
            {!loading ? (
                <div className={`${styles.spinnerDiv}`}>
                    <span>Loading...</span>
                </div>
            ) :
                parseInt(totalItems) === 0 ? (
                    <>
                        <div className={`${styles.noNotificationDiv}`}>
                            <span className={`${styles.noNotificationSpan}`}>
                                Nothing is on transit
                            </span>
                            <img src={nothing} alt='Waiting for orders' style={{ height: '60px' }} />
                        </div>
                    </>
                ) : (<>
                    <div className={`${styles.sellerDBMetricsDIV}`}>
                        <div className={`${styles.sellerDBMEtric}`}>
                            <span>
                                Total on transit items
                            </span>
                            <span>{totalItems}</span>
                        </div>
                        <div className={`${styles.sellerDBMEtric}`}>
                            <span>
                                Total on transit value
                            </span>
                            <span>{totalValue}</span>
                        </div>
                    </div>
                    {/* <button onClick={requestPickup} disabled={requestingPickup} className={`${styles.downloadInvoiceBtn}`}>
                        {requestingPickup ? 'Requesting pickup…' : 'Request Delhivery Pickup'}
                    </button> */}
                    <div>
                        <div className={`${styles.sellerDBPRODLS}`}>
                            {prodls && prodls.map((item, index) => {
                                return (
                                    <div className={`${styles.sellerOrderMainDiv}`}>
                                        <Link className={`${styles.sellerReturnDBAnchor}`} to={`${userUrl}/product/${item.prod}/${item.id}`} target="_blank">
                                            <span className={`${styles.sellerReturnDBFont}`}>{item.name}</span>
                                            <div>
                                                <img className={`${styles.sellerDBPRODIMG}`} id={index} src={`${S3_URL}/${item.photo1}`} alt={index}></img>
                                            </div>
                                            <div className={`${styles.sellerOrderAddressDiv}`}>
                                                <span className={`${styles.sellerReturnDBFont}`}>Name: {item.fname} {item.lname}</span>
                                                <span className={`${styles.sellerReturnDBFont}`}>House no: {item.houseno}</span>
                                                <span className={`${styles.sellerReturnDBFont}`}>Road: {item.roadName}</span>
                                                <span className={`${styles.sellerReturnDBFont}`}>Area:{item.areaName}</span>
                                                <span className={`${styles.sellerReturnDBFont}`}>City {item.city}</span>
                                                <span className={`${styles.sellerReturnDBFont}`}>Pin: {item.pin}</span>
                                                <span className={`${styles.sellerReturnDBFont}`}>Ph no. {item.phoneNo}</span>
                                                <span className={`${styles.sellerReturnDBFont}`}>Alt. Ph. No.{item.altPhoneNo}</span>
                                                <span className={`${styles.sellerReturnDBFont}`}>Price: {item.price}</span>
                                                <span className={`${styles.sellerReturnDBFont}`}>Size: {item.size}</span>
                                                <span className={`${styles.sellerReturnDBFont}`}>Quantity: {item.quantity}</span>
                                                <span className={`${styles.sellerReturnDBFont}`}>SKU: {item.sku}</span>
                                                {item.status && <span className={`${styles.sellerReturnDBFont}`}>Status: {item.status}</span>}
                                                
                                            </div>
                                        </Link>
                                        <button onClick={() => (downloadInvoice(item.purchaseId, item.name))}
                                            className={`${styles.downloadInvoiceBtn}`}>
                                            Download invoice
                                        </button>
                                    </div>
                                )
                            })}
                        </div>
                        <div style={noOfObs < 10 ? { display: 'none' } : { display: 'block' }}>
                            <button onClick={(e) => { changePage(e, true); setPageno(pageno - 1) }} style={pageno < 2 ? { display: 'none' } : { display: 'block' }}>Prev</button>
                            <span>{pageno}</span>
                            <button onClick={(e) => { changePage(e, false); setPageno(pageno + 1) }} >Next</button>
                        </div>
                    </div>
                </>)}

        </>
    )
}